import React, { useMemo } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import { useLocation } from "react-router-dom";

interface SiteWrapperProps {
  children: JSX.Element | JSX.Element[];
}

const SiteWrapper: React.FC<SiteWrapperProps> = ({ children }) => {
  const theme = useTheme();
  const screenSmallerThanLarge = useMediaQuery(theme.breakpoints.down("lg"));

  const location = useLocation();
  const currentPath = location.pathname;

  const ignorePadding = useMemo(() => {
    if (
      currentPath === "/chargerEstimator" ||
      currentPath.startsWith("/dashboard")
    ) {
      return true;
    }

    return false;
  }, [currentPath]);

  return (
    <div
      style={{
        ...(!ignorePadding
          ? { padding: `20px ${screenSmallerThanLarge ? "5%" : "10%"}` }
          : {}),
        // Guard against sideways scroll without also establishing a vertical
        // clip, so pages that grow taller than the viewport still scroll.
        overflowX: "hidden",
      }}
    >
      {children}
    </div>
  );
};

export default SiteWrapper;
